import { Select } from 'antd';
import type { ReactElement } from 'react';
import type { SelectEditorProps } from './types';

export function SelectEditor({ onValueChange, values, value }: SelectEditorProps): ReactElement {
  return (
    <Select
      open={true}
      optionFilterProp='label'
      defaultValue={value}
      variant='borderless'
      showSearch
      onChange={onValueChange}
      options={values}
      style={{ width: '100%' }}
    />
  );
}
